import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import LinearProgress from "@mui/material/LinearProgress";
import useAuth from "../../../hooks/useAuth";

export default function Step0({ onNext }) {
  const handleNext = () => {
    onNext();
  };
  const { user } = useAuth();
  const { settings } = user.company;
  const label = settings?.filter_field1 || "Client";

  return (
    <>
      <DialogContent>
        <Box minHeight={300} display="flex" alignItems="center">
          <Box width={320} margin="0 auto">
            <Box
              my={1}
              mb={5}
              alt="Warehouse worker moving inventory"
              component="img"
              borderRadius={2}
              width="100%"
              maxWidth={360}
              src="/pallet-count-assistant.png"
            />
            <Typography align="center" sx={{ mb: 4, fontWeight: 500 }}>
              {`I can help you share access to this customer so that other ${label.toLowerCase()} can also view this inventory`}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <LinearProgress variant="determinate" value={50} />
      <Box px={2} py={1.5} display="flex" justifyContent="flex-end" alignItems="center">
        <Button variant="contained" color="primary" onClick={handleNext} sx={{ minWidth: 100 }}>
          Start
        </Button>
      </Box>
    </>
  );
}
